export * from './TopicRequestBuilder';
export * from './useBaseTopicRequestBuilder';
export * from './trafficParsers';
import { store } from 'src/main';

export const isTopicEntity = (entityType: string) => {
  return entityType === 'topic' || entityType === 'searchtermlist';
};

export const isTopicOrTopicGroupType = (entityType: string) => {
  return isTopicEntity(entityType) || entityType === 'topicgroup';
};

export const isOwnedTopicOrTopicGroup = (ownedByUserId: string) => {
  return ownedByUserId === store.getState().user?.session?.userId;
};

export const isCustomTopicOrTopicGroup = (sharedWithEntityId: string) => {
  return sharedWithEntityId !== null && sharedWithEntityId !== undefined;
};

export const isStandardTopicOrTopicGroup = (sharedWithEntityId: string) => {
  return !isCustomTopicOrTopicGroup(sharedWithEntityId);
};

export const getTopicOrTopicGroupType = (
  sharedWithEntityId: string,
  ownedByUserId: string
): 'Custom' | 'Owned' | 'Standard' => {
  if (ownedByUserId === store.getState().user?.session?.userId) {
    return 'Owned';
  }
  if (sharedWithEntityId !== null) {
    return 'Custom';
  }

  return 'Standard';
};
